import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { films } from '@/mocks/films';

type CategorySidebarProps = {
  activeId: string;
  activeSub?: string;
};

export default function CategorySidebar({ activeId, activeSub }: CategorySidebarProps) {
  return (
    <nav className="rounded-lg border border-background-300/70 bg-background-100 p-3">
      <p className="px-2 pb-2 pt-1 font-label text-[10px] tracking-[0.2em] text-foreground-500">全部内容分类</p>
      <ul className="space-y-0.5">
        {categories.map((category) => {
          const isActive = category.id === activeId;
          const count = films.filter((film) => film.category === category.id).length;
          return (
            <li key={category.id}>
              <Link
                to={`/category/${category.id}`}
                className={`flex cursor-pointer items-center gap-2.5 rounded-md px-2.5 py-2.5 text-[13px] transition-colors ${
                  isActive
                    ? 'bg-background-200 text-primary-400'
                    : 'text-foreground-700 hover:bg-background-200/60 hover:text-foreground-950'
                }`}
              >
                <i className={`${category.icon} text-[15px] ${isActive ? 'text-primary-500' : 'text-foreground-500'}`} />
                <span className="flex-1 truncate">{category.name}</span>
                <span className="font-label text-[10px] text-foreground-500">{count}</span>
              </Link>
              {isActive && (
                <ul className="mb-1 ml-4 mt-1 space-y-0.5 border-l border-background-300 pl-3">
                  <li>
                    <Link
                      to={`/category/${category.id}`}
                      className={`block rounded px-2 py-1.5 text-[12px] transition-colors ${
                        !activeSub ? 'text-primary-400' : 'text-foreground-600 hover:text-foreground-950'
                      }`}
                    >
                      该分类全部
                    </Link>
                  </li>
                  {category.children.map((child) => (
                    <li key={child.id}>
                      <Link
                        to={`/category/${category.id}?sub=${encodeURIComponent(child.name)}`}
                        className={`block rounded px-2 py-1.5 text-[12px] transition-colors ${
                          activeSub === child.name
                            ? 'text-primary-400'
                            : 'text-foreground-600 hover:text-foreground-950'
                        }`}
                      >
                        {child.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}